export default __webpack_public_path__ + "static/media/image2.f239f259.png";